import React from "react";
import axios from 'axios';
import { useEffect, useState } from 'react';
import Loader from "../components/Loader";
import faqimg from '../assets/images/faq.png';
import Accordion from 'react-bootstrap/Accordion';

function Faq() {


const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;


const [faqs, setFaqs] = useState([]);
const [faqCall, setFaqCall] = useState(false);

useEffect(() => {
    
    if(faqCall === false){
      loadFaqs();
    }
    setFaqCall(true);

 });


const loadFaqs = async()=>{

            const payload={}

            let res  = await axios.post(apiUrl+'get_nbn_faq',payload , { 'api-token': apiKey  }).then(async response => {

                if(response.status === 200){                  
                    let faqDatas = response.data.data.nbn_faq;
                    setFaqs(faqDatas);

                }else{
                  
                }
             
            }).catch(error => {   
                         
             

            }); 
} 




return (
     


    <div className="container">
      <section className="faq">
        <div className="row">
            <div className="col-lg-7 col-md-12">
                <div className="faq-header-title">
                    <h2>Frequently Asked Questions : NBN<sup>&reg;</sup> Service</h2>
                    <p>Before reaching out by phone, explore our comprehensive FAQ section for potential answers to your queries about NBN<sup>&reg;</sup> plans. We value your feedback and are here to assist you.</p>
                </div>

				<Accordion defaultActiveKey="1" className="faq-container">

				{faqs && faqs.map((faqdetails,i) =>

				      <Accordion.Item key={i} eventKey={i}>
				        <Accordion.Header className="collapsible">{faqdetails.nbn_faq_question}</Accordion.Header>
				        <Accordion.Body className='content'>
				        	{faqdetails.nbn_faq_answer}
				        </Accordion.Body>
				      </Accordion.Item>

				)}

				</Accordion>
				
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="faq-img" style={{width: '100%'}}>
              <center><img className="img-fluid" src={faqimg} alt="FAQ-image-NBN-plans" /></center>
              </div>
            </div>
        </div><br /><br />
    </section>
</div>


);



}

export default Faq;
